(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksPendingReviewRiskSelfAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state'];

    function Controller($scope, $state) {

        // With Tasks
        $scope.withTasks = function () {
            return $scope.pendingsReviewCountByName.riskAssessments > 0;
        };

        // Go To RiskSelfAssessment
        $scope.goToRiskSelfAssessment = function () {
            $state.go('riskSelfAssessmentAssess.assessor', { ItemPersonID: $scope.authenticatedUser.ItemPersonID });
        };
    }
})();